/* eslint-disable @typescript-eslint/unbound-method */
import { ChangeDetectionStrategy, Component, OnInit, ViewChild, inject, signal } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import {
  ApiError,
  ApiSearchResponse,
  ApiSuccessfulLogin,
  ApiResponseName,
  GenericApiResponse,
} from 'src/app/interfaces/api';
import { IStrapiDocument, RegisterEmail } from 'src/app/interfaces/strapi';
import { AuthService } from 'src/app/services/auth.service';

import { ResidenceService } from 'src/app/services/residence.service';
import { UserService } from 'src/app/services/user.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { ResidenceAddComponent } from 'src/app/shared/components/residence-add/residence-add.component';
import { ResidenceListComponent } from 'src/app/shared/components/residence-list/residence-list.component';
import { ResidenceLookupComponent } from 'src/app/shared/components/residence-lookup/residence-lookup.component';
import { UniAddComponent } from 'src/app/shared/components/uni-add/uni-add.component';
import { UniListComponent } from 'src/app/shared/components/uni-list/uni-list.component';
import { UniLookupComponent } from 'src/app/shared/components/uni-lookup/uni-lookup.component';
import { Residence } from 'src/app/shared/models/residence.model';
import { University } from 'src/app/shared/models/university.model';
import { User } from 'src/app/shared/models/user.model';
import { Regexes } from 'src/app/shared/regexes';
import { UniService } from 'src/app/services/uni.service';
import StrapiService from 'src/app/services/strapi.service';
import { IUpdateExistingAccountData } from 'src/app/shared/components/login-modal/login-modal.component';
import { PostcodeService } from 'src/app/services/postcode.service';
import { lastValueFrom } from 'rxjs';
import { NgIf } from '@angular/common';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaLoaderService, RecaptchaV3Module, ReCaptchaV3Service } from 'ng-recaptcha-2';
import { TooltipComponent } from '../../../shared/components/tooltip/tooltip.component';
import { ModalComponent as ModalComponent_1 } from '../../../shared/components/modal/modal.component';
import { TooltipModalComponent } from '../../../shared/components/tooltip-modal/tooltip-modal.component';
import { UniLookupComponent as UniLookupComponent_1 } from '../../../shared/components/uni-lookup/uni-lookup.component';
import { UniListComponent as UniListComponent_1 } from '../../../shared/components/uni-list/uni-list.component';
import { UniAddComponent as UniAddComponent_1 } from '../../../shared/components/uni-add/uni-add.component';
import { ResidenceLookupComponent as ResidenceLookupComponent_1 } from '../../../shared/components/residence-lookup/residence-lookup.component';
import { ResidenceListComponent as ResidenceListComponent_1 } from '../../../shared/components/residence-list/residence-list.component';
import { UserUpdateChoiceComponent } from '../../../shared/components/user-update-choice-modal/user-update-choice-modal.component';
import { LoginModalComponent } from '../../../shared/components/login-modal/login-modal.component';
import { ErrorBlockComponent } from '../../../shared/components/error-block/error-block.component';
import { RegModalComponent } from '../reg-modal/reg-modal.component';
import environment from '../../../../environments/environment';

@Component({
    selector: 'app-register-email',
    templateUrl: './register-email.component.html',
    styleUrls: ['./register-email.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        TooltipComponent,
        ModalComponent_1,
        TooltipModalComponent,
        UniLookupComponent_1,
        UniListComponent_1,
        UniAddComponent_1,
        ResidenceLookupComponent_1,
        ResidenceListComponent_1,
        UserUpdateChoiceComponent,
        LoginModalComponent,
        ErrorBlockComponent,
        RegModalComponent,
    ],
  providers: [
    ReCaptchaV3Service,
    RecaptchaLoaderService,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.google.recaptcha_site_key }
  ]
})
export class RegisterEmailComponent extends PageComponent implements OnInit {
  public mode = signal<'email' | 'social'>('email');

  // uni lookup modal stuff
  @ViewChild('uniLookupModal') public readonly uniLookupModal!: ModalComponent;

  public showUniLookupModal = signal(false);

  @ViewChild('uniLookup') public readonly uniLookup!: UniLookupComponent;

  public uniLookupSearchTerm = signal('');

  // uni list modal stuff
  @ViewChild('uniListModal') public readonly uniListModal!: ModalComponent;

  public showUniListModal = signal(false);

  @ViewChild('uniList') public readonly uniList!: UniListComponent;

  // uni add modal stuff
  @ViewChild('uniAddModal') public readonly uniAddModal!: ModalComponent;

  public showUniAddModal = signal(false);

  @ViewChild('uniAdd') public readonly uniAdd!: UniAddComponent;

  // residence lookup modal stuff
  @ViewChild('residenceLookupModal')
  public readonly residenceLookupModal!: ModalComponent;

  public showResidenceLookupModal = signal(false);

  @ViewChild('residenceLookup')
  public readonly residenceLookup!: ResidenceLookupComponent;

  public residenceLookupSearchTerm = signal('');

  // residence list modal stuff
  @ViewChild('residenceListModal')
  public readonly residenceListModal!: ModalComponent;

  public showResidenceListModal = signal(false);

  @ViewChild('residenceList')
  public readonly residenceList!: ResidenceListComponent;

  // residence add modal stuff
  @ViewChild('residenceAddModal')
  public readonly residenceAddModal!: ModalComponent;

  public showResidenceAddModal = signal(false);

  @ViewChild('residenceAdd')
  public readonly residenceAdd!: ResidenceAddComponent;

  // other stuff
  public override pageData: RegisterEmail = <RegisterEmail>{};

  public registerForm!: UntypedFormGroup;

  public submitted = signal(false);

  public termsAndConditionsAccepted = signal(false);

  public privacyAndCookiesAccepted = signal(false);

  public showTC = signal(false);

  public showPC = signal(false);

  public registrationError = signal(false);

  public registrationErrorMessage = signal('');

  public addUniPrefill = signal('');

  public addResidencePrefill = signal('');

  public registering = signal(false);

  public loadingUni = signal(false);

  public loadingAccommodation = signal(false);

  public universityUUID: string | null = '';

  public accommodationUUID: string = '';

  public showTooltipModal = signal(false);

  public tooltipModalContent = signal('');

  public accommodationStayingText = signal<string | null>(null);

  public accommodationInputTooltipId = signal('');

  public isPPSelected = signal(false);

  public universityInputText = signal<string | null>(null);

  public universityInputTooltipId = signal('');

  public isUnihomeDeeplink = signal(false);

  public showUserUpdateChoice = signal(false);

  public showLoginModal = signal(false);

  public passedPostcodeValidation = signal(true);

  private recaptchaV3Service = inject(ReCaptchaV3Service);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly formBuilder: UntypedFormBuilder,
    private readonly userService: UserService,
    private readonly residenceService: ResidenceService,
    public readonly auth: AuthService,
    private readonly router: Router,
    public readonly uniService: UniService,
    public readonly postcodeService: PostcodeService,

  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi.getRegistrationEmailPage().subscribe({
      next: (data: IStrapiDocument<RegisterEmail>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
      },
      complete: () => {
        this.processDeeplink();

      },
    });

    // if a user has been stored in session for social reg, just in case they refresh, then get them out
    this.auth.loadSocialUserIfInSession();
    this.initializeForms();

    this.registerForm.get('postcode')?.valueChanges.subscribe(() => {
      this.registerForm
        .get('postcode')
        ?.patchValue(this.registerForm.get('postcode')?.value.toUpperCase(), {
          emitEvent: false,
        });
    });

    // Will check if the user has changed the univeristy or accommodation and will clear local storage when they do
    this.registerForm.valueChanges.subscribe({
      next: (changes: RegisterForm) => {
        if (
          changes.university_id !== '' &&
          changes.university_id !== this.universityUUID
        ) {
          localStorage.removeItem('unihomesFlow');
          localStorage.removeItem('universityCmsID');
        }

        if (
          changes.residence_id !== '' &&
          changes.residence_id !== this.accommodationUUID
        ) {
          // if a user has changed the value
          localStorage.removeItem('accommodationCmsId');
        }
      },
    });
  }

  /**
   * Initialize registration forms
   *
   * @returns void
   */
  public initializeForms(): void {
    this.registerForm = this.formBuilder.group({
      referrer: [this.auth.referrer],
      university_id: ['', { validators: [Validators.required] }],
      university_name: [''],
      residence_id: ['', { validators: [Validators.required] }],
      residence_name: [''],
      first_name: ['', { validators: [Validators.required], updateOn: 'blur' }],
      surname: ['', { validators: [Validators.required], updateOn: 'blur' }],
      postcode: ['', { updateOn: 'blur' }],
      accept_tc: ['', [Validators.requiredTrue]],
      accept_pc: ['', [Validators.requiredTrue]],
      is_above_17: ['', [Validators.requiredTrue]],
    });

    // if the auth service has a social user set, then we're here because they've used social login but haven't finished
    // all fields for social are already set, it's just the email version of the form that needs email and password fields
    // UPDATE: Apple social sign in only gives us the user's name on the first sign in. Future ones only contain a JWT with the email address in.
    if (this.auth.socialUser) {
      this.mode.set('social');
      if (this.auth.socialUser.firstName)
        this.registerForm
          .get('first_name')
          ?.setValue(this.auth.socialUser.firstName);
      if (this.auth.socialUser.lastName)
        this.registerForm
          .get('surname')
          ?.setValue(this.auth.socialUser.lastName);
      this.registerForm.get('email')?.setValue(this.auth.socialUser.email);
    } else {
      this.registerForm.addControl(
        'email',
        new UntypedFormControl('', {
          validators: [
            Validators.email,
            Validators.required,
            Validators.pattern(Regexes.emailRegex),
          ],
          updateOn: 'blur',
        })
      );
      this.registerForm.addControl(
        'password',
        new UntypedFormControl('', {
          validators: [
            Validators.required,
            Validators.pattern(Regexes.passwordRegex),
          ],
          updateOn: 'blur',
        })
      );
      this.registerForm.addControl(
        'confirm_password',
        new UntypedFormControl('', {
          validators: [Validators.required, this.confirmAreEqual.bind(this)],
          updateOn: 'blur',
        })
      );
    }

  }

  /**
   * Process any deeplinked universities and/or accommodation in local storage and pre-load
   * them into the input box
   *
   * @returns void
   */
  public processDeeplink(): void {
    // If these items dont exist in local storage variables will be null
    const universtiyCmsID = localStorage.getItem('universityCmsID');
    const accommodationCmsID = localStorage.getItem('accommodationCmsId');
    // process university deeplink
    if (universtiyCmsID) {
      this.loadingUni.set(true);
      switch (universtiyCmsID) {
        case 'im-not-at-university':
          this.handleNotAtUni();
          break;
        default:
          this.getUniversityViaDeeplink(universtiyCmsID);
          break;
      }
    } else {
      this.setDefaultUniversityFields();
    }

    // process accommodation deeplink
    if (accommodationCmsID) {
      this.loadingAccommodation.set(true);
      switch (accommodationCmsID) {
        case 'im-living-at-home':
          this.handleAlternateResidence(accommodationCmsID);
          break;
        case 'i-have-a-private-let-or-rental':
          this.handleAlternateResidence(accommodationCmsID);
          break;
        default:
          this.getAccommodationViaDeeplink(accommodationCmsID);
          break;
      }
    }
  }

  /**
   * if a deeplink university is present then fetch that university from the database
   * @return void
   */
  public getUniversityViaDeeplink(uniUid: string): void {
    this.uniService
      .getUniversityByCmsUID(uniUid)
      .pipe()
      .subscribe({
        next: (response) => {
          const university = <GenericApiResponse<University>>response;
          if (university) {
            this.processRetrievedUniversity(university.data);
          }
        },
        error: () => {
          this.loadingUni.set(false);

        },
        complete: () => {
          this.loadingUni.set(false);

        }, // stop loading once request is complete
      });
  }

  /**
   * set university in form controls and process for Unihome and normal deeplinks
   * @param university
   * @returns void
   */
  public processRetrievedUniversity(university: University): void {
    this.isUnihomeDeeplink.set(university.is_unihome_product ?? false);
    this.universityUUID = university.uuid;
    // Set the retrieved university in the university form control
    this.registerForm.controls['university_name'].patchValue(university.name); // sets university name to form with id
    this.registerForm.controls['university_id'].patchValue(this.universityUUID);

    if (this.isUnihomeDeeplink()) {
      this.universityInputText.set(this.pageData.unihome_university_name);
      this.universityInputTooltipId.set('unihome_university_name_tooltip');
      this.registerForm
        .get('postcode')
        ?.setValidators([
          Validators.required,
          Validators.pattern(Regexes.postcodeRegex),
        ]);
    } else {
      this.setDefaultUniversityFields();
    }
    this.processAccommodationText(university);
  }

  public setDefaultUniversityFields(): void {
    this.universityInputTooltipId.set('university_name_tooltip');
    this.universityInputText.set(this.pageData.university_name);
  }

  /**
   * If there is a accommodation deeplink uid, fetch that accommodation from the database
   * @param accommodationUid
   * @returns void
   */
  public getAccommodationViaDeeplink(accommodationUid: string): void {
    this.residenceService
      .getAccommodationByCmsUID(accommodationUid)
      .pipe()
      .subscribe({
        // Get accommodation name by UUID
        next: (response) => {
          const accommodation = <ApiResponseName>response;
          if (accommodation) {
            this.accommodationUUID = accommodation.data.uuid;
            this.registerForm.controls['residence_name'].patchValue(
              accommodation.data.name
            ); // sets accommodation name to form with id
            this.registerForm.controls['residence_id'].patchValue(
              this.accommodationUUID
            );
          }
        },
        error: () => {
          this.loadingAccommodation.set(false);

        },
        complete: () => {
          this.loadingAccommodation.set(false);

        },
      });
  }

  /**
   * show uni lookup modal
   * @returns
   */
  public displayUniLookupModal() {
    if (this.isUnihomeDeeplink()) return;
    this.showUniLookupModal.set(true);
    this.uniLookup.giveFocus();
  }

  /**
   * show uni lookup modal
   * @param $event
   * @returns
   */
  public displayUniListModal($event: Event) {
    if (this.isUnihomeDeeplink()) return;
    $event.stopPropagation();
    $event.preventDefault();
    this.showUniListModal.set(true);
  }

  /**
   * show accommodation lookup modal
   * @returns void
   */
  public displayResidenceLookupModal() {
    this.showResidenceLookupModal.set(true);
    this.residenceLookup.giveFocus();
  }

  /**
   * show residence list modal
   * @param $event
   * @returns void
   */
  public displayResidenceListModal($event: Event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.showResidenceListModal.set(true);
  }

  /**
   * Confirm passwords are the same
   * @param confirmField
   * @returns
   */
  private confirmAreEqual(
    confirmField: AbstractControl
  ): ValidationErrors | null {
    if (this.registerForm) {
      if (confirmField.value === this.registerForm.get('password')?.value)
        return null;
      return { NotEqual: true };
    }
    return null;
  }

  public get formControl(): {
    [key: string]: AbstractControl;
  } {
    return this.registerForm.controls;
  }

  protected override parsePageData(page: RegisterEmail): void {
    this.pageData = page;
    this.accommodationStayingText.set(page.staying);
  }

  /**
   * Submit the registration form to the api
   * @param e
   * @returns void
   */
  public register(e: Event): void {
    e.preventDefault();
    this.submitted.set(true);

    if (this.registerForm.invalid) return;

    // reCAPTCHA V3
    this.recaptchaV3Service
      .execute('importantAction')
      .subscribe(async (token: string) => {
        // Using async IIFE as temporary workaround
        void (async () => {
          // verify the captcha response, will return a score of confidence 0 = bot 1 = human
          // Build user payload
          const newUser = new User();
          newUser.referrer = String(this.registerForm.get('referrer')?.value);
          newUser.firstName = String(this.registerForm.get('first_name')?.value);
          newUser.lastName = String(this.registerForm.get('surname')?.value);
          newUser.password = String(this.registerForm.get('password')?.value);
          newUser.universityId = String(
            this.registerForm.get('university_id')?.value
          );
          newUser.accommodationId = String(
            this.registerForm.get('residence_id')?.value
          );
          newUser.postcode = String(this.registerForm.get('postcode')?.value);

          newUser.isAbove17 = this.registerForm.get('is_above_17')?.value;

          await this.validateAndContinue();

          if (!this.passedPostcodeValidation()) return;

          if (this.mode() === 'social' && this.auth.socialUser) {
            // set the fields we're not getting from the form
            newUser.socialUserId = this.auth.socialUser.socialUserId;
            newUser.socialToken = this.auth.socialUser.socialToken;
            newUser.email = this.auth.socialUser.email;
            newUser.method = this.auth.socialUser.method;
            newUser.ssoProvider = this.auth.socialUser.method;

            this.registering.set(true);

            this.userService.registerSocialUser(newUser).subscribe({
              next: () => {
                this.auth.socialUser = null;

                // registration is done, clean up the session storage
                this.auth.clearSocialSession();

                this.auth
                  .socialLogin(String(newUser.socialToken), newUser.method)
                  .subscribe({
                    next: (user) => {
                      const theUser = <ApiSuccessfulLogin>user;
                      this.auth.login(theUser);
                      void this.router.navigate(['/app']);
                    },
                  });
              },
              error: (err: ApiError) => {
                if (
                  this.isUnihomeDeeplink() &&
                  err.error?.message.includes('exists')
                ) {
                  this.showUserUpdateChoice.set(true);
                } else {
                  this.registrationError.set(true);
                }
                this.registering.set(false); // complete doesn't run on error
              },
              complete: () => {
                this.registering.set(false);
              },
            });
          } else if (this.mode() === 'email') {
            newUser.email = String(this.registerForm.get('email')?.value);
            newUser.recaptchaToken = token;

            this.registering.set(true);

            this.userService.registerUserWithEmailAddress(newUser).subscribe({
              next: () => {
                this.navigateToSuccess();
              },
              error: (err: ApiError) => {
                if (
                  this.isUnihomeDeeplink() &&
                  err.error?.message.includes('exists')
                ) {
                  this.showUserUpdateChoice.set(true);
                } else {
                  this.registrationErrorMessage.set(err.error?.message ?? '');
                  this.registrationError.set(true);
                }
                this.registering.set(false);
              },
              complete: () => {
                this.registering.set(false);
              },
            });
          } else {
            // something else? display an error message.
            this.registrationError.set(true);
            this.registrationErrorMessage.set(
              'There was an unknown error processing your registration.'
            );
          }
        })();
      })

    // End of async IIFE
  }

  private navigateToSuccess(): void {
    void this.router.navigate(['/signup/success']);
  }

  public toggleTsAndCs(e: Event): void {
    if (!this.termsAndConditionsAccepted()) {
      e.preventDefault();
    }
    this.showTC.set(true);
  }

  public tcBoxClicked(e: Event): void {
    if (!this.termsAndConditionsAccepted()) {
      e.preventDefault();
      this.showTC.set(true);
    }
  }

  public tcAccepted(accepted: boolean): void {
    this.termsAndConditionsAccepted.set(accepted);
    if (this.termsAndConditionsAccepted()) {
      this.registerForm
        .get('accept_tc')
        ?.setValue(this.termsAndConditionsAccepted());
    } else {
      this.registerForm.get('accept_tc')?.setValue(null);
    }
  }

  public togglePsAndCs(e: Event): void {
    e.preventDefault();
    this.showPC.set(true);
  }

  public pcAccepted(accepted: boolean): void {
    this.privacyAndCookiesAccepted.set(accepted);
    if (this.privacyAndCookiesAccepted()) {
      this.registerForm
        .get('accept_pc')
        ?.setValue(this.privacyAndCookiesAccepted());
    } else {
      this.registerForm.get('accept_pc')?.setValue(null);
    }
  }

  /**
   * Do updates when user selects a university
   * @param university
   */
  public universitySelected(university: University): void {
    this.hideUniSelectionModals();
    this.registerForm.get('university_id')?.setValue(university.uuid);
    this.registerForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm.set(university.name);
    this.addUniPrefill.set(university.name);
    this.universityInputText.set(this.pageData.university_name);
    this.universityInputTooltipId.set('university_name_tooltip');
    this.processAccommodationText(university);
  }

  /**
   * Do updates when user enters a university
   * @param university
   */
  public universityEntered(university: University): void {
    this.registerForm.get('university_id')?.setValue(university.uuid);
    this.registerForm.get('university_name')?.setValue(university.name);
    this.uniLookupSearchTerm.set(university.name);
    this.universityInputText.set(this.pageData.university_name);
    this.universityInputTooltipId.set('university_name_tooltip');
    this.processAccommodationText(university);
    this.showUniAddModal.set(false);
  }

  public hideUniSelectionModals(): void {
    this.showUniLookupModal.set(false);
    this.showUniListModal.set(false);
  }

  async validateAndContinue() {
    if (this.isUnihomeDeeplink()) {
      try {
        await lastValueFrom(
          this.postcodeService.validatePostcode(
            this.registerForm.get('postcode')?.value as string
          )
        );
        this.passedPostcodeValidation.set(true);
      } catch (error) {
        this.passedPostcodeValidation.set(false);
        this.registerForm
          .get('postcode')
          ?.setErrors({ pattern: 'The entered postcode does not exist.' });
      }
    }
  }

  public changeShowAddUniModal(lookupTerm: string): void {
    this.hideUniSelectionModals();
    if (lookupTerm) {
      this.addUniPrefill.set(lookupTerm);
    }
    this.showUniAddModal.set(true);
  }

  public residenceSelected(residence: Residence): void {
    this.hideResidenceSelectionModals();
    this.registerForm.get('residence_id')?.setValue(residence.uuid);
    this.registerForm.get('residence_name')?.setValue(residence.name);
    this.residenceLookupSearchTerm.set(residence.name);
    this.addResidencePrefill.set(residence.name);
  }

  public residenceEntered(residence: Residence): void {
    this.registerForm.get('residence_id')?.setValue(residence.uuid);
    this.registerForm.get('residence_name')?.setValue(residence.name);
    this.residenceLookupSearchTerm.set(residence.name);
  }

  public hideResidenceSelectionModals(): void {
    this.showResidenceLookupModal.set(false);
    this.showResidenceListModal.set(false);
  }

  /**
   * For when user selects private rental or im living at home
   * @param slug
   * @returns void
   */
  public handleAlternateResidence(slug: string): void {
    this.residenceService.getResidenceBySlug(slug).subscribe({
      next: (residence) => {
        const theResidenceResponse = <ApiSearchResponse>residence;
        const res = <Residence>theResidenceResponse.data;
        this.registerForm.get('residence_id')!.setValue(res.uuid);
        this.registerForm.get('residence_name')!.setValue(res.name);
        this.hideResidenceSelectionModals();
        this.loadingAccommodation.set(false);

      },
    });
  }

  /**
   * Tooltip passes in id to fetch data from pageData
   * @param id
   */
  public openTooltip(id: string) {
    this.showTooltipModal.set(true);

    type PageDataIndex = keyof typeof this.pageData;

    const currentRoute = id as PageDataIndex;

    this.tooltipModalContent.set(this.pageData[currentRoute] as string);
  }

  /**
   * For when the user selects im not at university
   * @returns void
   */
  public handleNotAtUni(): void {
    this.uniService.getImNotAtUniversityObject().subscribe({
      next: (university) => {
        const theUniResponse = <ApiSearchResponse>university;
        const uni = <University>theUniResponse.data;
        this.registerForm.get('university_id')!.setValue(uni.uuid);
        this.registerForm.get('university_name')!.setValue(uni.name);
        this.uniLookupSearchTerm.set(uni.name);
        this.addUniPrefill.set(uni.name);
        this.accommodationStayingText.set(this.pageData.staying);
        this.isPPSelected.set(false);
        this.hideUniSelectionModals();
        this.loadingUni.set(false);

      },
    });
  }

  /**
   * When the accommodation changes, update the text and tooltip
   * @param uni
   * @returns void
   */
  public processAccommodationText(uni: University): void {
    if (this.isUnihomeDeeplink()) {
      this.accommodationStayingText.set(this.pageData.staying_unihome);
      this.accommodationInputTooltipId.set('staying_tooltip_unihomes');
      return;
    }

    if (uni.is_pathway_provider) {
      this.isPPSelected.set(true);
      this.accommodationStayingText.set(this.pageData.staying_pathway_provider);
      this.accommodationInputTooltipId.set('university_name_tooltip');
      return;
    }
    this.accommodationStayingText.set(this.pageData.staying);
    this.accommodationInputTooltipId.set('university_name_tooltip');
    this.isPPSelected.set(false);
  }

  private getAge(birthday: Date): number {
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  private overSixteen(dob: AbstractControl): ValidationErrors | null {
    if (this.registerForm) {
      const dateofbirth = new Date(
        Number(dob.get('dob_y')?.value),
        Number(dob.get('dob_m')?.value) - 1,
        Number(dob.get('dob_d')?.value)
      );

      if (this.getAge(dateofbirth) < 17) {
        return { TooYoung: true };
      }
    }
    return null;
  }

  get dobDirty() {
    return (
      this.registerForm.get('dob')?.get('dob_d')?.dirty &&
      this.registerForm.get('dob')?.get('dob_m')?.dirty &&
      this.registerForm.get('dob')?.get('dob_y')?.dirty
    );
  }

  get dobInvalid() {
    return (
      this.registerForm.get('dob')?.get('dob_d')?.errors ||
      this.registerForm.get('dob')?.get('dob_m')?.errors ||
      this.registerForm.get('dob')?.get('dob_y')?.errors
    );
  }

  /**
   * Process weather the user wants to update
   * their already existing account details
   * @param updateDetails
   */
  public handleExistingAccountChoice(updateDetails: boolean): void {
    if (updateDetails) {
      this.showLoginModal.set(true);
    }
    this.showUserUpdateChoice.set(false);
  }

  /**
   * return the data that needs to be updated
   * for an existing user account
   * @returns IUpdateExistingAccountData
   */
  public get getDetailsToUpdate(): IUpdateExistingAccountData {
    return {
      postcode: String(this.registerForm.get('postcode')?.value),
      universityId: String(this.registerForm.get('university_id')?.value),
      accommodationId: String(this.registerForm.get('residence_id')?.value),
    } as IUpdateExistingAccountData;
  }
}

export interface RegisterForm {
  university_id: string;
  unvierstiy_name: string;
  residence_id: string;
  residence_name: string;
  first_name: string;
  surname: string;
  dob: {
    dob_d: string;
    dob_m: string;
    dob_y: string;
  };
  accept_tc: boolean;
  accept_pc: boolean;
}
